import React, { Fragment } from 'react';
import CommentsBox from '../CommentsBox';

const Overview = ({ comments, name, overviewList, updateComments }) => {
    const renderOverviewFields = () => {
        const labels = Object.keys(overviewList);

        return labels.map(label => {
            return (
                <div className="overview-fields">
                    <label>{label}</label>
                    <div className="user-select-all">{overviewList[label]}</div>
                </div>
            );
        });
    };

    return (
        <Fragment>
            <div className="test-instance-overview-head">Overview</div>

            <div className="blue-line">
                <div className="overview-name user-select-all">{name}</div>
            </div>

            <div className="test-instance-overview-details">
                <div className="overview-main-details">{renderOverviewFields()}</div>

                <CommentsBox comments={comments} onSave={updateComments} />

                <div className="blue-line" />
            </div>
        </Fragment>
    );
};

export default Overview;
